module.exports = `${require.publicPath}smart-user.c66ee28d.png`;